import { api } from '@/lib/api';
import type { CalibrationPlanningParams, CalibrationPlanningResponse } from '../types';

export function getCalibrationPlanning(
  params?: CalibrationPlanningParams,
): Promise<CalibrationPlanningResponse> {
  return api.get<CalibrationPlanningResponse>(
    '/v4/calibration-certificates/planning',
    params as Record<string, unknown> | undefined,
  );
}
